import { render, staticRenderFns } from "./CreateUserIntegrationSettingsContact.vue?vue&type=template&id=0f2dd996&scoped=true&"
import script from "./CreateUserIntegrationSettingsContact.vue?vue&type=script&lang=js&"
export * from "./CreateUserIntegrationSettingsContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2dd996",
  null
  
)

export default component.exports